import React from 'react'
import PropTypes from 'prop-types'
import './ColorScale.css'

const ColorScale = ({ title, ranges, opacity, onDisplayValues }) => {
    const colorStyle = {
        opacity: opacity,
    }

    const isLightColor = (color) => {
        // Convertir el color hexadecimal a RGB
        const rgb = parseInt(color.substring(1), 16)
        const r = (rgb >> 16) & 0xff
        const g = (rgb >> 8) & 0xff
        const b = (rgb >> 0) & 0xff
        // Calcular la luminosidad relativa del color
        const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b
        // Devolver true si el color es claro, de lo contrario, false
        return luminance > 160
    }
    ranges.reverse()

    return (
        <div className="color-scale">
            <div className="title">{title}</div>
            <div className="color-ranges">
                {ranges.map((range, index) => {
                    let minVal = range.min

                    return (
                        <div key={index} className="color-range">
                            <div
                                className="color"
                                style={{
                                    backgroundColor: range.color,
                                    ...colorStyle,
                                }}
                            >
                                <span
                                    className={
                                        isLightColor(range.color)
                                            ? 'light-text'
                                            : 'dark-text'
                                    }
                                >
                                    {onDisplayValues
                                        ? onDisplayValues(minVal)
                                        : minVal.toFixed(1)}
                                </span>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default ColorScale

ColorScale.propTypes = {
    title: PropTypes.string,
    ranges: PropTypes.array,
    opacity: PropTypes.number,
    onDisplayValues: PropTypes.func,
}
